export default function Title(props) {
  return (
    <h1 className="relative py-5 text-3xl font-bold text-center text-white md:py-10 md:text-6xl">
      {props.children}
    </h1>
  );
}
